import React, {useRef, useEffect, useState, useContext} from 'react';
import {ViewContext} from './contexts/ViewContext';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';
import {
	createSidewalkLayer,
	createCurbLayer,
	createObstacleLayer,
	createHexagonLayer,
	createRouteLayers,
	zoomCity,
	loadData,
	updateMapLayers,
	setRouteData,
} from './utils/MapUtils';
import {cities} from './utils/Constants';

mapboxgl.workerClass = MapboxWorker;
mapboxgl.accessToken = 'pk.eyJ1Ijoicm91dGU0dSIsImEiOiJjaW5rYXV1bmgwMDZtdnZseTh0Z2l5azFnIn0.SjjQEIHK2qF7JR5BN3xgWg';

export default function Map() {
	const {view} = useContext(ViewContext);

	const mapContainer = useRef();
	const [lng, setLng] = useState(-1.0697);
	const [lat, setLat] = useState(50.8181);
	const [zoom, setZoom] = useState(11.75);
	const [map, setMap] = useState(null);
	const [routesCreated, setRoutesCreated] = useState(false);
	const [obstaclesLoaded, setObstaclesLoaded] = useState(false);

	let popup = new mapboxgl.Popup({
		closeButton: false,
		closeOnClick: false,
	});

	useEffect(() => {
		const map = new mapboxgl.Map({
			container: mapContainer.current,
			style: 'mapbox://styles/mapbox/light-v10',
			center: [lng, lat],
			zoom: zoom,
		});

		map.addControl(new mapboxgl.NavigationControl());

		map.on('load', () => {
			setMap(map);
			createSidewalkLayer(map, popup);
			createCurbLayer(map, popup);
			createObstacleLayer(map, popup);
			createHexagonLayer(map, popup);
			createRouteLayers(map, popup).then(() => setRoutesCreated(true));
		});

		map.on('move', () => {
			setLng(map.getCenter().lng.toFixed(4));
			setLat(map.getCenter().lat.toFixed(4));
			setZoom(map.getZoom().toFixed(2));
		});

		return () => map.remove();
	}, []);

	// SELECT CITY
	useEffect(() => {
		if (map) {
			const thisCity = cities.find((city) => city.name === view.selectedCity);
			zoomCity(map, thisCity);
			loadData(map, thisCity);
			if (map.getSource('routePoint') && map.getSource('route') && thisCity.routing)
				setRouteData(map, thisCity.routing);
		}
	}, [view.selectedCity, map, routesCreated]);

	//CHANGE VIEW OR FILTER
	useEffect(() => {
		if (map) {
			updateMapLayers(map, view.mapView, view.mapView == 'props' ? view.mapFilterProps : view.mapFilterIndices);
		}
	}, [view.mapView, view.mapFilterProps, view.mapFilterIndices, map, obstaclesLoaded, routesCreated]);

	let infotext = 'Hover the mouse over a layer to see more info!';
	if (view.mapView == 'routes') {
		infotext = 'Drag the markers to plan routes! [red: wheelchair | blue: walking]';
	}

	return (
		<React.Fragment>
			<div className="map-container" ref={mapContainer} />
			<div className="infobox">{infotext}</div>
		</React.Fragment>
	);
}
